
  import {Component, Vue} from "vue-property-decorator";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import Scan from "@/views/components/Scan/Scan2.vue";
  import config from "./config";
  import Form1 from "./Form1.vue";
  import Form2 from "./Form2.vue";
  import TableHeader from "./TableHeader.vue";
  import dayjs from "dayjs";
  import {LogHelper} from "@/common/LogHelper";

  import {
     checkCodesAndType, cloudPress, backFLowOperationCountUpload, repaitFactorySearch, repairSupply,
  } from "@/api/service";
  import {ApiQueryType, ModeType, ReceiveDataType, SendDataType} from "@/common/glboalconstant";
  import {
    playFailSound,
    NoticeVoiceInit,
  } from "@/common/voiceTip";

  import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
  import {DeviceItems2Module} from "@/store/modules/store_deviceitems2";
  import { SystemConfigModule } from "@/store/modules/store_systemconfig";

  @Component({
    name: "scanforrepairandsupply",
    components: {
      DeviceItems2,
      YtoTable,
      Form1,
      Form2,
      TableHeader,
      Scan,
    },
  })
  export default class extends Vue {
    public inputModel: inputDataModel_RepairSupply = {
      input_ScanCode: "",
      repairFactory: "",
      repairFactoryLable:"",
      circleLine: 0,
      maxLatticeNo: 0,
      deviceAttribute: 0,
    };
    public globalConfig: any = {};
    public loginData: any = {};
    public index = 1;
    public totalScanCount = "0";
    public config = config;
    public currentrow = null;
    public showList = [];
    public ytoCode = "";
    public deviceItems: deviceItem[] = [];
    public errormessage = "";
    public datahistory = [];
    public callbackmodel = {};
    public nTotalScanNum = 0;
    private timer;
    private uploading = false;
    public DataQueue = [];
    private m_bFirstGet = true;

    mounted() {
      try {
        NoticeVoiceInit();
        this.globalConfig = SystemConfigModule.globalData;
        this.loginData = SystemConfigModule.loginData;
      } catch (error) {
        LogHelper.WriteLog("维修发放扫描界面:初始化异常" + error);
      }
      console.log("2023-06-27 19：00 kuang")

      //注册相机回调条码事件
      if (typeof obj_CodeReader_Core !== "undefined") {
        obj_CodeReader_Core.registerJavaScriptCallback(
          "CodeReaderSetPackageData",
          (value) => {
            LogHelper.WriteLog(
              dayjs().format("YYYY-MM-DD HH:mm:ss SSS") + "得到快手条码:" + value
            );
            debugger;
            let data = JSON.parse(value);

            if (this.datahistory.includes(data.CodeInfo))
            {
              console.log("当前单号"+ data.CodeInfo +"已扫，舍去");
              LogHelper.WriteLog("当前单号"+ data.CodeInfo +"已扫，舍去");
              return;
            }

            let index = this.InsertDataToList(data.CodeInfo, "未上传", "");
            this.clearData();
            this.datahistory.push(data.CodeInfo);
            //异步上传数据
            this.DataQueue.unshift({
              rfid: data.CodeInfo,
              createTime: dayjs().valueOf(),
              repairFactory: this.inputModel.repairFactory,
              operationType: "NEW",
              expType: "",
              index: index
            });
          }
        );
        console.log('CodeReaderSetPackageData注册成功');
      }

      console.log('loaded')
      debugger;
      if (typeof obj_ScanForRepairAndSupply !== "undefined")
      {
        obj_ScanForRepairAndSupply.vueLoaded();
      }

      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
      this.timer = setInterval(() => {
        if (this.DataQueue.length) {
          if (this.uploading) {
            return;
          } else {
            try {
              this.uploading = true;
              this.RepairAndSupplyDataUploadNew();
            } catch (error) {
              console.log("error");
              console.log(error);
            } finally {
              this.uploading = false;
            }
          }
        }
      }, 300);

      debugger;
      if (typeof obj_DWS_Core !== "undefined")
      {
        obj_DWS_Core.registerJavaScriptCallback(
          "DWSReceiveDataSetPackageData",
          (value) => {
            console.log("DWS传输过来的参数");
            console.log(value);
            this.ReceiveDataEvent(JSON.parse(value));
          }
        );
      }
    }
    // 销毁组件前清除定时器
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    }

      //获取参数
    private getFormValue(element) {
      this.inputModel = element;
    }
    //DWS数据处理
    private ReceiveDataEvent(receiveDataEventArgs) {
      switch (receiveDataEventArgs.ReceiveDataType) {
        case ReceiveDataType.CameraState:
          LogHelper.WriteLog("收到底层数据:" + receiveDataEventArgs.JsonData);
          this.SetCameraState(
            JSON.parse(receiveDataEventArgs.JsonData.toString())
          );
          break;
        case ReceiveDataType.PackageData:
          LogHelper.WriteLog("收到底层数据:" + receiveDataEventArgs.JsonData);
          break;
        case ReceiveDataType.CodeCheck:
          LogHelper.WriteLog("收到底层数据，暂无逻辑处理:" + receiveDataEventArgs.JsonData);
          // if (this.inputModel.input_latticeNo == "" && !this.inputModel.check_macrocycle) {
          //   this.errormessage = "请输入下层线格口号";
          //   return;
          // }
          break;
        case ReceiveDataType.ErrorState:
          LogHelper.WriteLog(
            "收到底层错误状态码:" + receiveDataEventArgs.JsonData
          );
          break;
        case ReceiveDataType.ErrorInfo:
          LogHelper.WriteLog("收到底层错误信息:" + receiveDataEventArgs.JsonData);
          break;
      }
    }

    //DWS设置相机状态
    private SetCameraState(strCameraState) {
      let items = this.RefreshState(strCameraState);
      DeviceItems2Module.SetDeviceItemsState(items);

      if (this.m_bFirstGet) {
        this.m_bFirstGet = false;
        //等待200ms后尝试执行
        setTimeout(() => {
          obj_DWS_Core.hKSocketSynSendDataCallBack(
            SendDataType.Watermark,
            this.loginData.orgCode + "|" + this.loginData.orgName + "|335|回流"
          );
          LogHelper.WriteLog(
            "SendDataType.Watermark:" +
            this.loginData.orgCode +
            "|" +
            this.loginData.orgName +
            "|335|回流"
          );
        }, 0.2 * 1000);
      }

      return;
    }

    //DWS刷新设备状态信息
    private RefreshState(camera_State) {
      let result = [];
      for (let i = 1; i <= camera_State.cameraState.camList.length; i++) {
        let _info =
          "" +
          "设备" +
          i.toString() +
          "-" +
          "设备状态:" +
          camera_State.cameraState.camList[i - 1].camStatus +
          "-" +
          "设备模式:" +
          this.IsNullorEmptyorUndefined(
            camera_State.cameraState.camList[i - 1].camModel
          )
            ? ""
            : camera_State.cameraState.camList[i - 1].camModel +
            "-" +
            //$"是否有值:是-" +
            "设备Mac:" +
            camera_State.cameraState.camList[i - 1].camMac;

        result.push({
          title: _info,
          name: "设备" + i,
          status:
            camera_State.cameraState.camList[i - 1].camStatus == "1"
              ? "true"
              : "false",
        });
      }

      return result;
    }

    //字符串为null、空、未定义判断
    private IsNullorEmptyorUndefined(data) {
      if (data == null || data == undefined || data == "") {
        return true;
      } else {
        return false;
      }
    }
      //表格选择动作
    private currentRowChanged(element) {
      this.currentrow = element;
      this.callbackmodel = this.inputModel;
    }

    //清除参数
    private clearData() {
      this.ytoCode = "";
    }

    //扫描区扫码
    private ytocodeget() {
      try {
        debugger;
        var scanAreaContent = this.ytoCode.toUpperCase().toUpperCase().trim();
        if (scanAreaContent == "") {
          try {
            playFailSound();
            this.errormessage = "输入为空";
            return;
          } catch (Exception) {
            this.errormessage = "输入为空,警告提示音不存在";
            return;
          }
        }
        var reg1 = new RegExp(/^[A-Za-z0-9]+$/);
        if (!reg1.test(scanAreaContent)) {
          this.errormessage = "输入数据非法，只能输入数字和字母";
          return;
        }
        this.errormessage = "";

        if (this.inputModel.repairFactory == "" || this.inputModel.repairFactory == null)
        {
          this.errormessage = "维修工产不能为空，请选择";
          return;
        }

        //条码校验
        let temps = [];
        temps.push(scanAreaContent);
        var rgStr = checkCodesAndType(
          temps,
          "XPH"
        );

        var rg = JSON.parse(rgStr);
        if (rg.ResultCode != "200")
        {
          console.log("当前输入为非有效芯片号");
          LogHelper.WriteLog("非有效芯片号");
          this.errormessage = rg.Info + scanAreaContent;
          return;
        }
        debugger;
        if (this.datahistory.includes(scanAreaContent))
        {
          console.log("当前单号"+ scanAreaContent +"已扫，舍去");
          this.errormessage = "当前单号"+ scanAreaContent +"已存在，舍去"
          LogHelper.WriteLog("当前单号"+ scanAreaContent +"已扫，舍去");
          return;
        }

        let index = this.InsertDataToList(scanAreaContent, "未上传", "");
        this.datahistory.push(scanAreaContent);
        //异步上传数据
        this.DataQueue.unshift({
          rfid: scanAreaContent,
          createTime: dayjs().valueOf(),
          latticeNo: "",
          operationType: "NEW",
          expType: "",
          index: index
        });
      } catch (error) {
        LogHelper.WriteLog(error.message);
      }
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    }

    //插入表格
    private InsertDataToList(strcode, stateMsg, tips) {
      debugger;
      let datetime = dayjs();
      var data: any = {
        rfid: strcode,
        strScanTime: datetime.format("YYYY-MM-DD HH:mm:ss"),
        repairFactory: this.inputModel.repairFactoryLable,
        state: stateMsg,
        strTip: tips,
        index: this.index,
      };
      this.index++;
      this.showList.unshift(data);
      while (this.showList.length > 50) {
        this.showList.pop();
      }
      this.nTotalScanNum++;
      this.totalScanCount = this.nTotalScanNum.toString();
      return this.index;
    }

    //更新表格数据
    public UpdateListData(index, rfid, result, tips) {
      try {
        for (var i = 0; i < this.showList.length; i++) {
          debugger;
          if (this.showList[i].index == (index - 1) && this.showList[i].rfid == rfid && this.showList[i].state == "未上传") {
            this.showList[i].state = result;
            this.showList[i].strTip = tips;
            break;
          }
        }
      } catch (e) {

      }
    }

    //异步维修发放上传接口
    public RepairAndSupplyDataUploadNew() {
      try {
        if (this.DataQueue.length > 0) {
          let data = this.DataQueue.pop();
          debugger;

          let dataList = [];
          dataList.push({
            packId:"",//包签号
            scanTime:data.createTime,//扫描时间
            tagIfid:data.rfid//芯片号
          });
          let dataNew = {
            pdaSn:this.globalConfig.CompName,//PDA设备码
            relationSiteCode: this.inputModel.repairFactory,//关联网点编码
            remark:"", //操作备注
            scanCode:this.loginData.orgCode, //操作端编码
            scanManId:this.loginData.userCode,//扫描操作人
            scanTaskId:"",//扫描任务ID
            scanType:"24",//操作任务类型
            uploadDataList:dataList//
          }
          let apiParamInfo = {
            data:dataNew,
            sign:"",
            time:data.createTime
          }
          let request = {
            apiParamInfo:apiParamInfo
          }
          let stReturnStr = JSON.parse(repairSupply(JSON.stringify(request)));

          if (stReturnStr?.status == "0") {
            this.UpdateListData(data.index, data.rfid, "上传成功", stReturnStr?.message);
          }
          else
          {
            this.UpdateListData(data.index, data.rfid, "上传失败", stReturnStr?.message)
          }
        }
      } catch (e) {
        debugger;
      }
    }

    //新异常走件接口，add by klm 20220420
    public NewAbnormalMovingPartUpload(
      strCode,
      strInfo,
      strIoTypeName = null,
      exceptionCode = null) {
      try {
        let ioType = null;
        let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
        let signsure = obj_HttpRequest_Core.getSignature("8606", datetimeNow);

        let _request = {
          mty: "8606",
          signature: signsure,//登录时需要获取的签名
          createTime: datetimeNow,
          waybillNo: strCode,
          containerNo: "",//容器号,非必填
          deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
          deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
          errorCode: exceptionCode,//异常码，必填
          errorMsg: strInfo,//异常信息，必填
          opCode: "334",//操作码，非必填
          ioType: ioType,//收发类型，非必填
          nextOrgCode: "",//下一网点，非必填
          weight: "",//重量，非必填
          createUserCode: this.loginData.userCode,
          extend1: "",
          extend2: "",
          extend3: ""
        };
        let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
        if (stReturnStr?.code == "000") {
          LogHelper.WriteLog("新异常走件方法上传成功");
        } else {
          LogHelper.WriteLog("新异常走件上传失败,返回异常码：" + stReturnStr?.code + "异常信息：" + stReturnStr?.msg);
        }
      } catch (ex) {
        LogHelper.WriteLog("新异常走件接口调用异常" + ex);
      }
    }

    //获取焦点
    private selectElementContents(el) {
      el.blur();
      el.focus();
    }
  }
